<ng-container *ngIf="field">
	<div class="row">
		<div [ngClass]="field.UIOptions.customTemplateOptions.descriptionContainerClass">
			<p class="subtitle">{{ field.DisplayText }}</p>
			<p class="description-label" *ngIf="field.description">{{ field.description }}</p>
		</div>

		<div [ngClass]="field.UIOptions.customTemplateOptions.fieldElementClass">
			<div *ngIf="!field.UIOptions?.SelectChips?.hideSearch" class="flex-auto input-field-container select-chips {{field.customClass}}">
				<span class="p-input-icon-left">
    				<i class="pi pi-search"></i>
					<p-autoComplete
						[disabled]="field.disabled"
						(completeMethod)="searchOptions($event)"
						(onSelect)="addSelectedOption($event)"
						[showEmptyMessage]="true"
						[minLength]="1"
						[(ngModel)]="searchValue"
						field="label"
						[suggestions]="options"
						[forceSelection]="true"
					></p-autoComplete>
				</span>
				<button
					pButton
					icon="pi pi-plus-circle"
					type="button"
					label="Add"
					[disabled]="control.disabled"
					(click)="addNewOption()"
					class="p-button-success"></button>
			</div>

			<button
				pButton
				*ngIf="field.UIOptions?.SelectChips?.showAddAction"
				icon="pi pi-plus-circle"
				type="button"
				label="Add"
				[disabled]="control.disabled"
				(click)="addNewOption()"
				class="p-button-success new-table-element-button"></button>
		</div>

		<div class="items-selected-container">
			<p-chip *ngFor="let item of data;let i = index;" [removable]="!control.disabled && field.UIOptions?.SelectChips?.removable"
					(onRemove)="removeItem(i)">
				<span class="chips-label" *ngIf="field.UIOptions?.SelectChips?.isDate">{{item | date: field.UIOptions?.SelectChips?.dateFormat }}</span>
				<span class="chips-label" *ngIf="!field.UIOptions?.SelectChips?.isDate" >{{ item }}</span>
			</p-chip>

			<div class="row" *ngIf="field.UIOptions?.counterLabel">
				<div class="counter-container">
					<p class="counter-label">{{data?.length || 0}} {{field.UIOptions.counterLabel}}</p>
				</div>
			</div>
		</div>
	</div>
</ng-container>
